module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Clothes/Tie-98e40f73e180cad695ac4b187743a8b9.svg";